/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiWebInstytucjeNipPlikiPost$Params {
  nip: string;
  'Content-Disposition'?: {
};
  'X-Strona'?: string;
}

export function apiWebInstytucjeNipPlikiPost(http: HttpClient, rootUrl: string, params: ApiWebInstytucjeNipPlikiPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiWebInstytucjeNipPlikiPost.PATH, 'post');
  if (params) {
    rb.path('nip', params.nip, {});
    rb.header('Content-Disposition', params['Content-Disposition'], {});
    rb.header('X-Strona', params['X-Strona'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiWebInstytucjeNipPlikiPost.PATH = '/api/web/instytucje/{nip}/pliki';
